import state from "./moduleQAState.js";
import mutations from "./moduleQAMutations.js";
import actions from "./moduleQAActions.js";
import getters from "./moduleQAGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
